<template>
    <div>
        <div class="body" id="main-container">
            <el-aside>
                <div class="leftcontent">
                    <div class="lefttop">
                        <div class="avatar-icon">
                            <img :src="userInfo.avatar" class="avatar" />
                            <svg class="icon" aria-hidden="true" v-if="userInfo.role_no == 4">
                                <use xlink:href="#iconzhuanjia" />
                            </svg>
                        </div>
                        <p class="username">{{userInfo.nickname}}</p>
                        <div class="tagmid">
                            <p class="city">{{userInfo.provincename}}</p>
                            <!-- <div class="line"></div> -->
                            <p class="city">{{userInfo.work}}</p>
                        </div>
                        <!-- <p class="tag">{{tag}}</p>
                        <p class="email">{{email}}</p>-->
                        <div class="money">
                            <p class="yue">余额：</p>
                            <p class="surplus">{{userInfo.balance}}</p>
                            <el-button class="chongzhi" type="primary" round @click="recharge">充值</el-button>
                        </div>
                    </div>
                    <div class="leftmid">
                        <div class="focus">
                            <p class="focustext">关注了</p>
                            <p class="num">{{userInfo.follownum}}</p>
                        </div>
                        <div class="focus">
                            <p class="focustext">粉丝</p>
                            <p class="num">{{userInfo.bfollownum}}</p>
                        </div>
                    </div>
                    <div class="leftbottom">
                        <div class="menuitem" @click="handlecollection()">
                            <div class="activeline" v-show="collectionshow"></div>
                            <p class="menutitle">我的收藏</p>
                        </div>
                        <div class="menuitem" @click="handlefocus()">
                            <div class="activeline" v-show="focusshow"></div>
                            <p class="menutitle">我的关注</p>
                        </div>
                        <div class="menuitem" @click="handlemessage()">
                            <div class="activeline" v-show="messageshow"></div>
                            <p class="menutitle">我的消息</p>
                        </div>
                        <div class="menuitem" @click="handlecomment()">
                            <div class="activeline" v-show="commentshow"></div>
                            <p class="menutitle">文章评论</p>
                        </div>
                        <div class="menuitem" @click="handlerecord()">
                            <div class="activeline" v-show="recordshow"></div>
                            <p class="menutitle">消费记录</p>
                        </div>
                        <div class="menuitem" @click="handlesystem()">
                            <div class="activeline" v-show="systemshow"></div>
                            <p class="menutitle">系统通知</p>
                        </div>
                        <div class="menuitem" @click="handlepersonal()">
                            <div class="activeline" v-show="personalshow"></div>
                            <p class="menutitle">个人中心</p>
                        </div>
                    </div>
                </div>
            </el-aside>
            <el-main class="personal-center">
                <mycollections v-if="collectionshow"></mycollections>
                <myfocus v-if="focusshow"></myfocus>
                <mymessage v-if="messageshow && show" @messageChat="chat"></mymessage>
                <mycomment v-if="commentshow"></mycomment>
                <myrecord v-if="recordshow"></myrecord>
                <systemnotification v-if="systemshow"></systemnotification>
                <personal v-if="personalshow"></personal>
                <chat :info="info" ref="chat" @close="close" @messageChat="messageChat"></chat>
            </el-main>
        </div>
    </div>
</template>
<script>
    import mycollections from '@/components/personalcenter/mycollections.vue';
    import myfocus from '@/components/personalcenter/myfocus.vue';
    import mymessage from '@/components/personalcenter/mymessage.vue';
    import mycomment from '@/components/personalcenter/mycomment';
    import myrecord from '@/components/personalcenter/myrecord.vue';
    import systemnotification from '@/components/personalcenter/systemnotification.vue';
    import personal from '@/components/personalcenter/personal.vue';
    import Chat from '../../components/common/Chat';
    import { mapActions, mapGetters } from 'vuex';
    export default {
        components: {
            mycollections,
            myfocus,
            mymessage,
            mycomment,
            myrecord,
            systemnotification,
            personal,
            Chat
        },
        data() {
            return {
                collectionshow: true,
                focusshow: false,
                messageshow: false,
                commentshow: false,
                recordshow: false,
                systemshow: false,
                personalshow: false,
                buid: '',
                info: {}, // 要对话的人信息
                show: true // 对话框是否显示的并列条件
            };
        },
        computed: {
            ...mapGetters(['userInfo'])
        },
        created() {
            this.refresh();
        },
        mounted() {
            var height = document.body.clientWidth;
            console.log(height);
            var width = document.body.clientHeight;
            console.log(width);
            this.getUserInfo();
            if (this.$route.query.buid) {
                this.buid = this.$route.query.buid;
                this.show = false;
                this.handlemessage();
                this.showUserChat();
            }
        },
        methods: {
            ...mapActions(['getUserInfo']),
            refresh() {
                if (this.$route.query.type == 'messageshow') {
                    this.handlemessage();
                } else if (this.$route.query.type == 'systemshow') {
                    this.handlesystem();
                }
            },
            recharge() {
                this.$router.push({
                    name: 'recharge'
                });
            },
            close() {
                this.show = true;
                this.$router.push({ query: { buid: '' } });
            },
            handlecollection() {
                this.$refs.chat.close();
                this.collectionshow = true;
                this.focusshow = false;
                this.messageshow = false;
                this.commentshow = false;
                this.recordshow = false;
                this.systemshow = false;
                this.personalshow = false;
            },
            handlefocus() {
                this.$refs.chat.close();
                this.collectionshow = false;
                this.focusshow = true;
                this.messageshow = false;
                this.commentshow = false;
                this.recordshow = false;
                this.systemshow = false;
                this.personalshow = false;
            },
            handlemessage() {
                this.collectionshow = false;
                this.focusshow = false;
                this.messageshow = true;
                this.commentshow = false;
                this.recordshow = false;
                this.systemshow = false;
                this.personalshow = false;
            },
            handlecomment() {
                this.$refs.chat.close();
                this.collectionshow = false;
                this.focusshow = false;
                this.messageshow = false;
                this.commentshow = true;
                this.recordshow = false;
                this.systemshow = false;
                this.personalshow = false;
            },
            handlerecord() {
                this.$refs.chat.close();
                this.collectionshow = false;
                this.focusshow = false;
                this.messageshow = false;
                this.commentshow = false;
                this.recordshow = true;
                this.systemshow = false;
                this.personalshow = false;
            },
            handlesystem() {
                // this.$refs.chat.close();
                this.collectionshow = false;
                this.focusshow = false;
                this.messageshow = false;
                this.commentshow = false;
                this.recordshow = false;
                this.systemshow = true;
                this.personalshow = false;
            },
            handlepersonal() {
                this.$refs.chat.close();
                this.collectionshow = false;
                this.focusshow = false;
                this.messageshow = false;
                this.commentshow = false;
                this.recordshow = false;
                this.systemshow = false;
                this.personalshow = true;
            },
            chat() {
                this.show = false;
                this.handlemessage();
                this.showUserChat();
            },
            showUserChat() {
                this.httpGet(this.$root.getUserInfo, {
                    uid: this.buid
                })
                    .then(result => {
                        this.info = result;
                        this.$nextTick(() => {
                            this.$refs.chat.openChat();
                            setTimeout(() => {
                                this.getUserInfo();
                            }, 1000);
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            messageChat(id) {
                this.$router.replace({
                    name: 'personal-center',
                    query: {
                        buid: id
                    }
                });
            }
        },
        watch: {
            '$route.query.buid': function(newValue, oldValue) {
                if (newValue) {
                    this.show = false;
                    this.buid = newValue;
                    this.handlemessage();
                    this.showUserChat();
                }
            },
            '$route.query.type': function(newValue, oldValue) {
                this.refresh();
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .body {
        display: flex;
        flex-direction: row;
    }

    .leftcontent {
        margin-top: 20px;
        display: flex;
        flex-direction: column;

        .lefttop {
            background-color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 280px;
            border-radius: 8px;
            padding-bottom: 20px;
            box-sizing: border-box;

            .avatar-icon {
                position: relative;
                margin-top: 32px;

                .icon {
                    width: 30px;
                    height: 30px;
                    fill: #f0c328;
                    position: absolute;
                    right: 5px;
                    top: -18px;
                    transform: rotate(20deg);
                    -ms-transform: rotate(20deg); /* IE 9 */
                    -moz-transform: rotate(20deg); /* Firefox */
                    -webkit-transform: rotate(20deg); /* Safari 和 Chrome */
                    -o-transform: rotate(20deg); /* Opera */
                }
            }

            .avatar {
                width: 80px;
                height: 80px;
                border-radius: 50px;
            }

            .username {
                margin-top: 16px;
                font-size: 16px;
                font-weight: bold;
            }

            .tagmid {
                margin-top: 4px;
                display: flex;
                flex-direction: row;
                align-items: center;

                .city {
                    font-size: 12px;
                    color: #000000;
                    opacity: 0.45;
                    margin: 0 5px;
                }

                .line {
                    width: 1px;
                    height: 10px;
                    background-color: #D8D8D8;
                    margin-left: 4px;
                    margin-right: 4px;
                }
            }

            .tag {
                margin-top: 9px;
                font-size: 12px;
                color: #000;
                opacity: 0.85;
                ellipsis();
            }

            .money {
                margin-top: 19px;
                display: flex;
                flex-direction: row;
                align-items: center;

                button {
                    margin-left: 5px;
                }

                .yue {
                    font-size: 14px;
                    opacity: 0.85;
                    font-weight: bold;
                }

                .surplus {
                    color: #FFA300;
                    font-size: 14px;
                }

                .chongzhi {
                    height: 28px;
                    width: 54px;
                    padding: 0;
                }
            }
        }
    }

    .leftmid {
        border-radius: 8px;
        margin-top: 8px;
        background-color: white;
        width: 280px;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        .focus {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .focustext {
                font-size: 12px;
                opacity: 0.25;
            }

            .num {
                font-size: 16px;
                margin-top: 6px;
            }
        }
    }

    .leftbottom {
        border-radius: 8px;
        margin-top: 8px;
        background-color: white;
        display: flex;
        flex-direction: column;

        .menuitem {
            cursor: pointer;
            display: flex;
            width: 280px;
            height: 54px;
            align-items: center;

            .menutitle {
                font-size: 14px;
                margin-left: 20px;
            }

            .activeline {
                width: 4px;
                height: 20px;
                background-color: #4093FF;
            }
        }
    }

    .rightcontent {
    }
</style>
